import React from "react";
import { ErrorBoundary } from "react-error-boundary";

import ReactErrorPage from "./ReactErrorPage";

const ReactErrorBoundary = (props: { children: JSX.Element }): JSX.Element => {
  return (
    <React.Fragment>
      <ErrorBoundary
        FallbackComponent={ReactErrorPage}
        onError={(error, errorInfo) => {
          console.log("Error caught!");
          console.error({ error });
          console.error({ errorInfo });
        }}
        onReset={(details) => {
          console.log({ details });
          console.log("Reloading the page...");
          window.location.reload();
        }}
      >
        {props.children}
      </ErrorBoundary>
    </React.Fragment>
  );
};

export default ReactErrorBoundary;
